<template>
    <div class="poi-detail-content">
        <template v-if="poiData">            
            <POIPictures :poi="poiData"/>
            <POIVideoPicture :poi="poiData"/>
            <POIAddBase :poi="poiData"/>
            <POIFavouriteNote :text="foundFavourite.comment" v-if="foundFavourite && foundFavourite.comment &&foundFavourite.comment !== ''" />
            <POIIntroText v-if="poiData.introText" :text="poiData.introText" />
            <POIInfo :poi="poiData" v-if="poiData.type !== 'nearbyStations'"/>
            <POINearby v-if="poiData.nearbyPOIs" :poi="poiData"  />
            <POITrafficMessages v-if="poiData.trafficMessages" :poi="poiData" />
            <StationMonitor v-if="poiData.stationId" :station-id="poiData.stationId" :lines="poiData.lines" :activePoi="activePoi" />
        </template>
        <div class="sidebar__section" v-if="loadingDetail">
            <ContentLoader />
        </div>
    </div>
</template>

<script>
import * as api from '@/api';
import { mapGetters } from 'vuex';
import eventBus from '@/utils/event-bus';
import { getBasicPreparedPoiData, getAdvancedPreparedPoiData, getCoordinatesObject } from '@/utils/poi-utils'
import POIPictures from '@/components/POIPictures.vue'
import POIVideoPicture from '@/components/POIVideoPicture.vue'
import POIAddBase from '@/components/POIAddBase.vue'
import POIFavouriteNote from '@/components/POIFavouriteNote.vue'
import POIInfo from '@/components/POIInfo.vue'
import POINearby from '@/components/POINearby.vue'
import POITrafficMessages from '@/components/POITrafficMessages.vue'
import POIIntroText from '@/components/POIIntroText.vue'
import ContentLoader from '@/components/ContentLoader.vue'

export default {
    components: {
        POIPictures,
        POIVideoPicture,
        POIAddBase,
        POIFavouriteNote,
        POIInfo,
        POINearby,
        POITrafficMessages,
        POIIntroText,
        ContentLoader,
        StationMonitor: () => import(/* webpackChunkName: "StationMonitor" */ '@/components/StationMonitor.vue'),
    },
    props: {
        poiId: {
            type: String,
            default: '',
        },
        activePoi: {
            type: [Boolean, Object],
            default: false,
        },
        poiType: {
           type: String,
            default: '' 
        },
        poiApiType: {
            type: String,
            default: ''
        },
        foundFavourite: {
            type: [Object, Boolean],
            default: false
        },
        isChild: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loadedPoi: false,
            loadingDetail: false,
            activeTab: '1',
            poiData: false,
        }
    },
    created() {
        if(this.activePoi) this.loadedPoi = this.activePoi
        this.getDetail();
        this.addListeners()
    },
    beforeDestroy() {
        this.removeListeners()
    },
    watch: {
        activePoi(value) {
            if(value) {
                this.loadedPoi = value
                this.preparePoiData()
            }
        }
    },
    computed: {
        ...mapGetters(['activePoiId', 'customActivePoiType', 'customActivePoiSubType', 'user', 'allFavourites']),
    },
    methods: {
        poiFavouritesUpdateHandler() {
            this.getDetail()
        },
        addListeners() {
            eventBus.$on('poiFavouritesUpdated', this.poiFavouritesUpdateHandler)
        },
        removeListeners() {
            eventBus.$off('poiFavouritesUpdated', this.poiFavouritesUpdateHandler)
        },
        preparePoiData() {
            if(!this.loadedPoi) {
                return false;
            }
            let basicData = getBasicPreparedPoiData(this.loadedPoi.poiType, this.loadedPoi);
            let advancedData = getAdvancedPreparedPoiData(this.loadedPoi.poiType, this.loadedPoi);
            const data = {...basicData, ...advancedData}
            data.coordinates = getCoordinatesObject(this.loadedPoi.poiType, this.loadedPoi)
            this.poiData = data;
        },
        async getDetail() {
            if(!this.loadedPoi) {
                if(!this.poiApiType) return

                let apiType = this.poiApiType
                try {
                    this.loadingDetail = true;
                    const response = await api.poi.getPOIbyID(apiType, this.poiId);
                    let responseData = response.data
                    let activePoiData = {
                        ...responseData,
                        poiType: this.poiType,
                        isChild: this.isChild
                    }
                    this.loadingDetail = false;
                    this.loadedPoi = activePoiData;
                    this.preparePoiData()
                } catch (e) {
                    console.error(e);
                }
            } else {
                this.preparePoiData()
            }
        }
    }
}
</script>

<style lang="scss">
.poi-detail {
    $block: &;
}
</style>